// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-th {
  height: 32px;
  padding: 0 var(--admin-s4);
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  color: var(--admin-text-muted);
  font-size: var(--admin-text-micro);
  font-weight: var(--admin-font-weight-bold);
  letter-spacing: 0.12em;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}

.au-th__button,
.au-th__label {
  display: inline-flex;
  align-items: center;
  gap: var(--admin-s2);
}

.au-th__button {
  border: 0;
  padding: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}

.au-th__button:hover {
  color: var(--admin-text-secondary);
}

.au-th__chevron {
  opacity: 0.32;
}

.au-th__chevron.is-active {
  opacity: 1;
  color: var(--admin-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminTh.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kDAAkD;EAClD,8BAA8B;EAC9B,kCAAkC;EAClC,0CAA0C;EAC1C,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC","sourcesContent":[".au-th {\n  height: 32px;\n  padding: 0 var(--admin-s4);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  color: var(--admin-text-muted);\n  font-size: var(--admin-text-micro);\n  font-weight: var(--admin-font-weight-bold);\n  letter-spacing: 0.12em;\n  text-align: left;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.au-th__button,\n.au-th__label {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--admin-s2);\n}\n\n.au-th__button {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  cursor: pointer;\n}\n\n.au-th__button:hover {\n  color: var(--admin-text-secondary);\n}\n\n.au-th__chevron {\n  opacity: 0.32;\n}\n\n.au-th__chevron.is-active {\n  opacity: 1;\n  color: var(--admin-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
